(() => {
  $(document).on(
    "click",
    ".product-form-standardSelector .item:not(.disabled)",
    function () {
      // update active styles
      $(this).siblings(".item").removeClass("active");
      $(this).addClass("active");

      // update selected option
      $(this)
        .closest(".option-wrapper")
        .find("label .sel")
        .text($(this).attr("data-sel-text") ?? $(this).attr("data-option"));

      // update and trigger dropdown
      let options = [];
      $(".option-wrapper .item.active").each(function () {
        options.push($(this).attr("data-option"));
      });
      const select = $("[name='variant_id']");
      select.val(select.find(`[data-option='${options.join(" / ")}']`).val());
      select.trigger("change");
    },
  );

  $("[name='variant_id']").on("change", function () {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", $(this).val());
    window.history.replaceState(null, "", url.toString());

    const option = $(this).find(`option[value='${$(this).val()}']`);
    $("#currentSelection").attr("data-variant", $(this).val());
    $("#currentSelection").attr("data-price", option.attr("data-price"));
    $("#currentSelection").attr("data-compare", option.attr("data-compare"));
    $("#currentSelection").attr(
      "data-stockNum",
      option.attr("data-stockIndicatorNum"),
    );
    $(".subtitle[data-variant_title]").text(option.attr("data-option") || "");

    updateLinks();
    updatePrice();
    updateInstallment();
    updateVoucher();

    toggleATCbuttons();
    updateImage();
    updateLeadTime();
    updateCheckoutBtn();
  });

  function toggleATCbuttons() {
    const atcButton = $("#AddToCart-button");
    const checkoutBtn = $("#initateCheckout");
    const soldOutBtn = $("#sold-out-btn");

    const selValue = $("[name='variant_id']").val();
    const selOption = $(`[name='variant_id'] option[value='${selValue}']`);

    if (selOption.attr("data-available") == "true") {
      atcButton.show();
      checkoutBtn.show();
      soldOutBtn.addClass("hide");
    } else {
      atcButton.hide();
      checkoutBtn.hide();
      soldOutBtn.removeClass("hide");
    }

    if (selOption.attr("data-preorder")) {
      //$("#initateCheckout").text("PRE-ORDER NOW");
    }
  }

  function updateImage() {
    const value = $("[name='variant_id']").val();
    const option = $(`[name='variant_id'] option[value='${value}']`);
    const handle = option.attr("data-handle");

    $(".product-single__thumbnails-items").removeClass("active");
    $(".product-single__thumbnails-items." + handle).addClass("active");

    $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
    $(".product-single__thumbnails-items.main." + handle + " a").addClass(
      "active-thumb",
    );

    $(".product-single__thumbnails-items.main a.active-thumb").click();
  }

  function updateLeadTime() {
    const option = $(
      `[name='variant_id'] option[value="${$("[name='variant_id']").val()}"]`,
    );

    if (option.attr("data-restock")) {
      $(".custom-attributes.product-restocks p").html(
        option.attr("data-restock"),
      );
    }
  }

  function updateCheckoutBtn() {
    const option = $(
      `[name='variant_id'] option[value="${$("[name='variant_id']").val()}"]`,
    );

    if (option.attr("data-checkout")) {
      $("#initateCheckout").text(option.attr("data-checkout"));
    }
  }

  toggleATCbuttons();
  updateImage();
  updateLeadTime();
  updateCheckoutBtn();
  
  $(window).on("load", function () {
    setTimeout(() => {
      $("[name='variant_id']").trigger("change");
    }, 300);
  });
})();
